export default __webpack_public_path__ + "4635d76e50af7b48dea363a0481c4540.png";